export enum AnalyticsActionSubject {
	ERROR_BOUNDARY = 'errorBoundary',
	MEMBER_PICKER = 'memberPicker',
	TEAM_TYPE_PICKER = 'teamTypePicker',
	TEAM_CREATE_DIALOG = 'teamCreateDialog',
	DROP_DOWN_MENU = 'dropdownMenu',
	ADD_TO_TEAM_SERVICE = 'addToTeamService',
	INVITE_TO_PRODUCT_SERVICE = 'inviteToProductService',
	INVITE_CAPABILITIES_SERVICE = 'inviteCapabilitiesService',
	INVITED_TEAM_MEMBERS = 'invitedTeamMembers',
	USER = 'user',
	MEMBER = 'member',
}

export enum AnalyticsAction {
	RENDERED = 'rendered',
	CLICKED = 'clicked',
	FAILED = 'failed',
	SUCCEEDED = 'succeeded',
	VIEWED = 'viewed',
	CLOSED = 'closed',
	ERROR = 'error',
	SUBMITED = 'submitted',
	FETCHED = 'fetched',
	SENT = 'sent',
	INVITED = 'invited',
	REQUESTED = 'requested',
	ADDED = 'added',
	SUGGESTED = 'suggested',
}

export enum AnalyticsSource {
	PEOPLE_TEAMS = 'peopleTeams',
}
